import Control from './control';
import Doublebox from './doublebox';
import Singlebox from './singlebox';
import Opendesign from './opendesign';
import FreeAccount from './free-account';

import LaunchDarkly from '@module/launchdarkly';
import {
  EXPERIMENT_SPLASHPAGE_COPY,
  EXPERIMENT_FREE_ACCOUNT,
} from '@constant/experiments';

let component = Control;

if (LaunchDarkly.getVariant(EXPERIMENT_FREE_ACCOUNT)) {
  component = FreeAccount;
} else {
  const variant = LaunchDarkly.getVariant(EXPERIMENT_SPLASHPAGE_COPY);

  const VariantToComponentMap = {
    doublebox: Doublebox,
    singlebox: Singlebox,
    opendesign: Opendesign,
  };

  component = VariantToComponentMap[variant] || Control;
}

export default component;
